export default __webpack_public_path__ + "static/media/5.b2c2b59f.png";